import {JourneyMap, MapInDashboard} from "../API";


/** 作成マップ上限(開発時に一度に取得する数をこれにしたので、ひとまず仮置き)  */
const MAX_MAP_COUNT = 20;

export class DashboardMaps {

    private maps: MapInDashboard[];

    constructor(maps: MapInDashboard[]) {
        this.maps = maps;
    }

    get empty(): boolean {
        return this.maps.length === 0;
    }

    get isCreatable(): boolean {
        return this.maps.filter(m => m.collaboratorType === 'owner').length < MAX_MAP_COUNT;
    }


    get hasPrivateMap(): boolean {
        return this.maps.some(m => m.collaboratorType === 'owner' && !m.isCollaborated);
    }

    get hasCollaboratedMap(): boolean {
        return this.maps.some(m => m.isCollaborated);
    }

    mappingPrivateMap<U>(converter: (m: MapInDashboard) => U): U[] {
        return this.maps.filter(m => m.collaboratorType === 'owner' && !m.isCollaborated).map(m => converter(m));
    }

    mappingCollaboratedMap<U>(converter: (m: MapInDashboard) => U): U[] {
        return this.maps.filter(m => m.isCollaborated).map(m => converter(m));
    }

    removeMap(map_id: string): DashboardMaps {
        return new DashboardMaps(this.maps.filter(m => m.mapId !== map_id));
    }

    addApiJourneryMap(new_map: JourneyMap) {
        if (!new_map.owner) {
            throw new Error("no owner");
        }
        if (!new_map.createdAt) {
            throw new Error("no createdAt");
        }
        if (!new_map.updatedAt) {
            throw new Error("no updatedAt");
        }

        const new_dashboard_map: MapInDashboard = {
            __typename: "MapInDashboard",
            mapId: new_map.id,
            owner: new_map.owner,
            title: new_map.title,
            version: new_map.version,
            preview: new_map.preview,
            updatedAt: new_map.updatedAt,
            createdAt: new_map.createdAt,
            collaboratorType: 'owner',
            isCollaborated: false
        };

        return new DashboardMaps([new_dashboard_map].concat(this.maps));
    }

    static fromApi(maps: MapInDashboard[]) {
        return new DashboardMaps(maps);
    }

}
